import { IComponentNode } from 'app/app/editor/index.functions';
import { findElementContainerUid } from 'app/app/editor/page/index';

export function getNodeWithParentByUid(
    page: IComponentNode,
    uid: string,
): { node: IComponentNode; parentNode: IComponentNode; nodeIndex: number } | false {
    const container = findElementContainerUid(page, uid);
    if (container == null) {
        return false;
    }
    let parentNode = page;
    const path = container.match(/(?:\d+)+/gm) as Array<string>;
    if (path) {
        for (let i = 0; i < path.length; i++) {
            // Node with this path should always exist
            parentNode = parentNode!.elements![Number(path[i])];
        }
    }
    const nodeIndex = parentNode!.elements!.findIndex((e) => e.params.uid == uid);
    const node = parentNode!.elements![nodeIndex];
    return { node, parentNode, nodeIndex };
}

export function getNodeByUid(page: IComponentNode, uid: string) {
    const node = getNodeWithParentByUid(page, uid);
    return node ? node.node : false;
}
